export const colors = {
  green1: "#006B5B",
  green2: "#007E6B",
  green3: "#25823A",
  green4: "#B2D8D3",
  lightGreen: "#ECF1F0",
  lightYellow: "#F9F7F1",
  red1: "#DA2C2C",
  orange1: "#F47A35",
  orange4: "#F9F7F1",
  brown: "#97664A",
  black: "#000000",
  grey1: "#666666",
  grey2: "#999999",
  grey3: "#D9D9D9",
  grey4: "#EEEEEE",
  grey5: "#DFDFDF",
  yellow: "#F3C141",
  white: "#FFFFFF",
  scrollbar: "#BABAC0",
};

export type Colors = typeof colors;
